/* eslint-disable react/prop-types */
import { useEffect, useRef } from 'react'
import { Button, Modal, Spinner } from 'flowbite-react'
import { IComponenteDeCreditoResponse } from '@/interfaces/componente-de-credito'
import { getStoredValue } from '@/hooks/common/use-session-storage'

interface ResultadoModalProps {
    isOpen: boolean | false
    onClose: () => void
    result?: IComponenteDeCreditoResponse
    isLoading: boolean | false
}

const getModalContent = (result?: IComponenteDeCreditoResponse) => {
    
    if (!result || !result.conteudo || !result.sucesso || result.conteudo.erro || result.conteudo.situacao?.toLowerCase() === 'erro') {
        return {
            img: '/images/guia.svg',
            title: 'Falha no carregamento do pedido',
            message: (
                <>
                Por favor, tente novamente. <br />
                Se o erro persistir, contate nosso suporte.
                </>
            ),
            buttonTitle: 'Fechar'
        }
    }

    const unifiedBilling = getStoredValue('unifiedBilling') === 'true';
    const billingClosingDay = getStoredValue('billingClosingDay');
    if (result.conteudo.situacao?.toLowerCase() === 'liberado' && unifiedBilling) {
        return {
            img: '/images/Greeting.svg',
            title: 'Pedido liberado para compra',
            message: (
                <>
                    Este pedido faz parte do modelo cobrança unificada.<br />
                    O boleto será gerado no dia {billingClosingDay}, com todos os<br />
                    pedido do período, em uma única cobrança.<br />
                    <small>Obs: Fique atento ao prazo de vencimento após o fechamento.</small>
                </>
            ),
            buttonTitle: 'Confirmar'
        }
    }

    if (result.conteudo.situacao?.toLowerCase() === 'liberado' && !unifiedBilling) {
        return {
            img: '/images/Greeting.svg',
            title: 'Pedido liberado para compra',
            message: (
                <>
                    Você já pode baixar o boleto para realizar o pagamento.<br />
                    <small>Obs: Fique atento ao prazo de vencimento.</small>
                </>
            ),
            buttonTitle: 'Confirmar'
        }
    }

    return {
        img: '/images/guia.svg',
        title: 'Não estamos conseguindo processar seu pedido',
        message: 'Aguarde que nosso time entrará em contato em breve.',
        buttonTitle: 'Fechar'
    }
}


const ResultadoModal: React.FC<ResultadoModalProps> = ({
    isOpen,
    onClose,
    result,
    isLoading
}) => {
    const closeBtnRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        if (isOpen && closeBtnRef.current) {
            closeBtnRef.current.focus();
        }
    }, [isOpen]);

    const modalContent = getModalContent(result);

    return (
        <Modal
            show={isOpen}
            onClose={onClose}
            aria-label="Resultado do pedido de crédito"
            size='md' 
        >
            <Modal.Body>
                <div className="flex flex-col items-center text-center">
                    {isLoading ? (
                        <div className="flex flex-col items-center justify-center py-8">
                            <Spinner size="xl" aria-label="Carregando" />
                            <div className="text-center">Carregando...</div>
                        </div>
                    ) : (
                        <div className="flex flex-col items-center gap-4">
                            <img
                                src={modalContent.img}
                                alt={typeof modalContent.title === 'string' ? modalContent.title : ''}
                                width={140}
                                height={140}
                                aria-hidden="true"
                            />
                            <strong className="text-lg">{modalContent.title}</strong>
                            <div className="text-center">{modalContent.message}</div>
                            <br />
                        </div>
                    )}
                    {!isLoading && (
                        <div className='flex justify-center gap-4'>
                            <Button
                                ref={closeBtnRef}
                                onClick={onClose}
                                aria-label="Fechar modal"
                                type="button"
                            >
                                {modalContent.buttonTitle}
                            </Button>
                        </div>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default ResultadoModal